import map from "astrid-helpers/src/map";
import useMouseXY from "astrid-hooks/src/useMouse";
import { useOffset } from "../state/offset";
import { useRect } from "../state/rect";
import { useSize } from "../state/size";
export default function useMouse() {
  const size = useSize();
  const rect = useRect();
  const offset = useOffset();
  const {
    x,
    y
  } = useMouseXY(rect);
  return {
    x: offset + map(x, 0, rect.width, 0, size),
    y: y / rect.height
  };
}
//# sourceMappingURL=useMouse.js.map